import { handleValidationChange } from "../CommonValidation"

export const validateItems = (data, setIsError) => {
  console.log(data)
  var isValid = true

  if (data.name === "" || data.name === undefined) {
    handleValidationChange("name", true, setIsError)
    isValid = false
  } else {
    handleValidationChange("name", false, setIsError)
    isValid = true
  }
  if (
    data.inhouse_barcode === "" ||
    data.inhouse_barcode === undefined ||
    data.inhouse_barcode === null
  ) {
    handleValidationChange("inhouse_barcode", true, setIsError)
    isValid = false
  } else {
    handleValidationChange("inhouse_barcode", false, setIsError)
    isValid = true
  }
  if (data.sales_type === "" || data.sales_type === undefined) {
    handleValidationChange("sales_type", true, setIsError)
    isValid = false
  } else {
    handleValidationChange("sales_type", false, setIsError)
    isValid = true
  }
  if (
    data.category[0].value === "" ||
    data.category[0].value === undefined ||
    data.category[0].value === null
  ) {
    handleValidationChange("category", true, setIsError)
    isValid = false
    console.log(isValid)
  } else {
    handleValidationChange("category", false, setIsError)
    isValid = true
  }

  return isValid
}


// to check if sales items required filleds have data
export const validatePurchaseItems = (items) => {
        const errors = {};
        console.log(items)
        items.map((item, itemIndex) => {
        if ((!item.hasOwnProperty('description') || ((item.hasOwnProperty('description') && !item.description))) 
            && (item.item_id === '' || item.item_id === null || item.item_id === undefined)) {
            errors[itemIndex] = {
            ...errors[itemIndex],
            description: 'Item or description is required',
            };
        }

        if (!(item.qty.toString())|| (parseInt(item.qty) <= 0)) {
          errors[itemIndex] = {
            ...errors[itemIndex],
            qty: 'Qty is required and make sure it is greater than 0',
          };
        }

        if (!(item.unit.toString())||item.unit==='') {
          errors[itemIndex] = {
            ...errors[itemIndex],
            unit: 'Unit is required',
          };
        }

        if (!item.price || (parseInt(item.price) <= 0)) {
          errors[itemIndex] = {
            ...errors[itemIndex],
            price: 'Price is required and make sure it is greater than 0',
          };
        }

        });

        return errors;

}

